import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  isFetching: false,
  data: {}
};

export default function env (state = initialState, action) {
  const { error, type, data } = action;

  switch (type) {
  case types.PAYLOAD_CLEAR_STORE:
    return _.merge({}, state, initialState);

  case types.PAYLOAD_UPDATE_REQUEST:
    return _.merge({}, state, {
      isFetching: true
    });

  case types.PAYLOAD_UPDATE_SUCCESS:
    return {
      ...state,
      data,
      isFetching: false
    };

  case types.PAYLOAD_UPDATE_FAILURE:
    return _.merge({}, state, {
      error,
      isFetching: false
    });

  default:
    return state;
  }
}
